import { render } from "./AvailableMenuComponent.vue?vue&type=template&id=3b61d3a8"
import script from "./AvailableMenuComponent.vue?vue&type=script&lang=js"
export * from "./AvailableMenuComponent.vue?vue&type=script&lang=js"

import "./AvailableMenuComponent.vue?vue&type=style&index=0&id=3b61d3a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__